(ns entities.estate.specs
  (:require
    [cljs.spec.alpha :as s]
    )
  )

(s/def ::attorney (s/nilable string?))
(s/def ::disclosure-submitted boolean?)
(s/def ::documents-created (s/nilable string?)) ;; date, technically
(s/def ::documents-submitted boolean?)
(s/def ::successor (s/nilable string?))

(s/def ::estate (s/nilable (s/keys :req-un [::attorney
                                            ::disclosure-submitted
                                            ::documents-created
                                            ::documents-submitted
                                            ::successor])))
